import { render, staticRenderFns } from "./DetalheOfertaTitulo.vue?vue&type=template&id=3fddc252&scoped=true"
import script from "./DetalheOfertaTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheOfertaTitulo.vue?vue&type=style&index=0&id=3fddc252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fddc252",
  null
  
)

export default component.exports